import React from 'react';

export const PaymentsModalTitle = ({ title }: { title: string }) => (
	<div className="w-full p-2 font-serif">
		<h2 className="text-2xl font-bold text-center">{title}</h2>
	</div>
);

PaymentsModalTitle.displayName = 'PaymentsModalTitle';
